import { render, staticRenderFns } from "./CollectionFilter.vue?vue&type=template&id=181591a9&scoped=true&"
import script from "./CollectionFilter.vue?vue&type=script&lang=js&"
export * from "./CollectionFilter.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFilter.vue?vue&type=style&index=0&id=181591a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181591a9",
  null
  
)

export default component.exports